// SPDX-License-Identifier: AGPL-3.0-or-later

import {Endpoints} from '@app/features/app/constants/Endpoints';
import {http} from '@app/features/platform/transport/RestTransport';
import type {
	BatchRaidPruneRequest,
	BatchRaidPruneResponse,
	GuildAntiRaidStatusResponse,
	RecentJoinsResponse,
	TogglePanicLockdownRequest,
	UpdateAntiRaidSettingsRequest,
} from '@fluxer/schema/src/domains/guild/GuildAntiRaidSchemas';

export async function getAntiRaidStatus(guildId: string): Promise<GuildAntiRaidStatusResponse> {
	const response = await http.get<GuildAntiRaidStatusResponse>(Endpoints.GUILD_ANTI_RAID(guildId));
	return response.body;
}

export async function togglePanicLockdown(
	guildId: string,
	data: TogglePanicLockdownRequest,
): Promise<GuildAntiRaidStatusResponse> {
	const response = await http.post<GuildAntiRaidStatusResponse>(Endpoints.GUILD_ANTI_RAID_PANIC(guildId), {
		body: data,
	});
	return response.body;
}

export async function getRecentJoins(guildId: string, withinMinutes = 30): Promise<RecentJoinsResponse> {
	const response = await http.get<RecentJoinsResponse>(Endpoints.GUILD_ANTI_RAID_RECENT_JOINS(guildId, withinMinutes));
	return response.body;
}

export async function batchRaidPrune(
	guildId: string,
	data: BatchRaidPruneRequest,
): Promise<BatchRaidPruneResponse> {
	const response = await http.post<BatchRaidPruneResponse>(Endpoints.GUILD_ANTI_RAID_PRUNE(guildId), {
		body: data,
	});
	return response.body;
}

export async function updateAntiRaidSettings(
	guildId: string,
	data: UpdateAntiRaidSettingsRequest,
): Promise<GuildAntiRaidStatusResponse> {
	const response = await http.patch<GuildAntiRaidStatusResponse>(Endpoints.GUILD_ANTI_RAID_SETTINGS(guildId), {
		body: data,
	});
	return response.body;
}
